export const mapAppUserToAppUserDisplayObject = (user) => {
  return {
    id: user?.identities?.[0]?.user_id || "",
    name: user?.name || "",
    nickname: user?.nickname || "",
    email: user?.email || "",
    emaid: user?.emaid || "",
    permissions:
      user?.permissions?.map((p) => p?.permission_name).join(" | ") || "",
    connection: user?.identities?.[0]?.connection,
  };
};

// Helper function to format ISO dates to a readable format
export const formatDate = (dateString) => {
  if (!dateString) return "—";
  try {
    return new Date(dateString).toLocaleString("en-US", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return dateString;
  }
};
